(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_pdt_list"] && !Shopify.designMode) return;
  try {
    
(() => {
  function start(root) {
    root.querySelectorAll('[custom_pdt_list_section]').forEach(section => {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      const track = section.querySelector('[grid_block]');
      const previous = section.querySelector('[carousel_prev]');
      const next = section.querySelector('[carousel_next]');
      if (!track || !previous || !next) return;
      const update = () => { previous.disabled = track.scrollLeft <= 1; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1; };
      previous.addEventListener('click', () => track.scrollBy({left: -track.clientWidth, behavior: 'smooth'}));
      next.addEventListener('click', () => track.scrollBy({left: track.clientWidth, behavior: 'smooth'}));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', () => start(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
            // product carousel active
            $('.releted_product_slider').slick({
                speed: 1000,
                adaptiveHeight: true,
                prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>'
            }); 
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
